import { render, staticRenderFns } from "./loginFooter.vue?vue&type=template&id=e0217f4e&scoped=true&"
import script from "./loginFooter.vue?vue&type=script&lang=ts&"
export * from "./loginFooter.vue?vue&type=script&lang=ts&"
import style0 from "./loginFooter.vue?vue&type=style&index=0&id=e0217f4e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0217f4e",
  null
  
)

export default component.exports